export const API_URL = '/accuracy-api/api';
